import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import Device from "./DeviceBox";
import Chart from "./Chart";
import Filters from "./Filters";
import "./button-group.scss";
import { connect } from "react-redux";
import { DataAction } from "./redux/actions/DataActions";
import { MessageAction } from "./redux/actions/MessageActions";

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = (dispatch) => ({
  addMessage: (message, type) =>
    dispatch(MessageAction.addMessage(message, type)),
  updateChartData: () => dispatch(DataAction.updateChartData()),
  changeApi: (deviceid, apikey) => dispatch(DataAction.changeApi(deviceid, apikey)),
});

require("moment/locale/fi");

const compareData = (a, b) => {
  if (a?.name < b?.name) return -1;
  if (a?.name > b?.name) return 1;
  if (a?.deviceid < b?.deviceid) return -1;
  if (a?.deviceid > b?.deviceid) return 1;
  return 0;
};

const chartConfigs = [
  { title: "Teho", xName: "power", unit: "W" },
  { title: "Matkamittari", xName: "odometer", unit: "km" },
  { title: "CPU", xName: "cpu", unit: "" },
  { title: "Tiedostoja", xName: "numFiles", unit: "" },
  { title: "Muistia jäljellä", xName: "memFree", unit: " MB", divider: 1024 },
  { title: "Levytilaa jäljellä", xName: "freespace", unit: " GB", divider: 1024 * 1024 * 1024 },
  { title: "co2", xName: "co2", unit: " ppm", averageKey: "co2" },
  { title: "Ilmanpaine", xName: "pressure", unit: " Pa", averageKey: "pressure", altTitle: "Paine-ero", altType: "ruuvi" },
  { title: "Lämpötila", xName: "temperature", unit: " °C", averageKey: "temperature" },
  { title: "Ilmankosteus", xName: "humidity", unit: " %RH", averageKey: "humidity" },
  { title: "Compressor speed RPM", xName: "Compressor speed RPM", unit: " (RPM)", averageKey: "Compressor speed RPM" },
  { title: "Brine in", xName: "Brine in", unit: " °C", averageKey: "Brine in" },
  { title: "Brine out", xName: "Brine out", unit: " °C", averageKey: "Brine out" },
  { title: "Conderser in temperature", xName: "Conderser in temperature", unit: " °C" },
  { title: "Conderser out temperature", xName: "Conderser out temperature", unit: " °C" },
  { title: "Discharge pipe temperature", xName: "Discharge pipe temperature", unit: " °C", averageKey: "Discharge pipe temperature" },
  { title: "Outdoor temperature", xName: "Outdoor temperature", unit: " °C", averageKey: "Outdoor temperature" },
  { title: "Tap water top", xName: "Tap water top", unit: " °C", averageKey: "Tap water top" },
  { title: "Tap water bottom", xName: "Tap water bottom", unit: " °C", averageKey: "Tap water bottom" },
];

function Data(props) {
  const { dataState, filterState, loginState } = props;
  const { data, busy } = dataState;
  const { showDetailedValues, sensors } = filterState;
  const { initializing, token } = loginState;

  useEffect(() => {
    document.title = "Anturien arvot - mitattu.fi";
    if (!data.length) {
      props.updateChartData();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    props.updateChartData();
    // eslint-disable-next-line
  }, [filterState.fromDate, filterState.toDate]);

  if (!initializing && !token) {
    props.addMessage("Ole hyvä ja kirjaudu ensin.", "warning");
    return <Navigate to="/" replace />;
  }

  if (!data || busy) {
    return <h1>Loading...</h1>;
  }

  const sortedData = [...data].sort(compareData);

  const Summaries = sortedData.map((item, key) => {
    if (
      typeof item !== "undefined" &&
      item.deviceid &&
      dataState[item.deviceid] &&
      sensors[item.deviceid]
    ) {
      const rawValues = dataState[item.deviceid];
      return (
        <React.Fragment key={key + "frag"}>
          <Device
            data={item}
            rawValues={rawValues}
            key={key}
            showCalculated={showDetailedValues}
            changeApi={props.changeApi}
          />
          <div className="charts" key={key + "charts"}>
            {chartConfigs.map((cfg, idx) => {
              // Handle alternate title for pressure
              let chartTitle = cfg.title;
              if (
                cfg.xName === "pressure" &&
                rawValues.data[0]?.type === cfg.altType
              ) {
                chartTitle = cfg.altTitle;
              }
              return (
                <Chart
                  key={cfg.xName + idx}
                  data={rawValues.data}
                  average={cfg.averageKey ? rawValues[cfg.averageKey] : {}}
                  title={chartTitle}
                  xName={cfg.xName}
                  unit={cfg.unit}
                  divider={cfg.divider}
                  sensorName={item}
                />
              );
            })}
          </div>
        </React.Fragment>
      );
    } else {
      if (sensors[item.deviceid]) {
        return <p key={"" + key + key}>Ei dataa valittuna ajanjaksona</p>;
      }
      return null;
    }
  });

  return (
    <div className="datapage">
      <Filters />
      <div className="devices">{Summaries}</div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Data);
